<template>
    <div id="tariff" class="tariff">
        <div class="container">
            <h2>{{ data.title }}</h2>
            <div class="__row">
                <div class="__col"
                    v-for="(item, index) in data.list"
                    :key="index"
                >
                    <ElemTicket
                        :title="item.title"
                        :description="item.description"
                        :cost="item.cost"
                        :options="item.options"
                        :buyKey="true"
                        :count="item.count"
                        @event-click-buy="() => { handleEventClickBay(item.id) }"
                    />
                </div>
                <div class="_col __company">
                    <button 
                        @click="handleClickBuyCompany"
                        :disabled=true
                    >ОПЛАТИТЬ КАК ЮРИДИЧЕСКОЕ ЛИЦО</button>
                </div>
            </div>
        </div>
        <Transition>
            <PopupBlock v-if="popup" @event-close-popup="handleEventClosePopup">
                <BuyForm v-if="privatePerson"
                    :statusOk="statusOk"
                    :complite="complite"
                    :waiting="waiting"
                    :promocodeEnabled="item.promocode"
                    @event-return-data="handleEventReturnData"
                    >
                    <ElemTicket
                        :title="item.title"
                        :description="item.description"
                        :cost="item.cost"
                        :options="item.options"
                        :buyKey="false"
                        :count="item.count"
                    />
                </BuyForm>
                <BuyFormOrganization v-else
                    :statusOk="statusOk"
                    :complite="complite"
                    :waiting="waiting"
                    :promocodeEnabled="item.promocode"
                    @event-return-data="handleEventReturnDataCompany"
                    >
                </BuyFormOrganization>
            </PopupBlock>
        </Transition>
        <!-- <Transition>
            <PopupBlock v-if="popupUrlic">

            </PopupBlock>
        </Transition> -->
    </div>
</template>
<script>
import axios from 'axios'
// import { getParam } from '@/lib/getParam'
import data from '@/lib/tariff'
import PopupBlock from './PopupBlock.vue'
import BuyForm from './BuyForm.vue'
import BuyFormOrganization from './BuyFormOrganization.vue'
import ElemTicket from './ElemTicket.vue'

export default {
    name: 'TariffBlock',
    components: { 
        PopupBlock,
        BuyForm,
        BuyFormOrganization,
        ElemTicket 
    },
    props: {},
    data() {
        return {
            data,
            popup: false,
            item: {},
            privatePerson: true,
            statusOk: true,
            complite: false,
            waiting: false,
        }
    },
    mounted() {
    },
    methods: {
        cost: function(value) {
            return Intl.NumberFormat('ru-RU', { 
                style: 'currency',
                currency: 'RUB',
                maximumFractionDigits: 0,
            }).format( value )
        },
        handleEventClickBay: function( id ) {
            // console.log('handleEventClickBay item id:', id)
            // console.log('getParam', getParam('devel'))
            
            // if( !(getParam('devel') == 1) ) {
            //     // промотка к форме
            //     document.querySelector( '.footer').scrollIntoView()
            //     window.scrollBy( 0, -60 )
            //     return
            // }

            this.item = this.data.list.find( item => id === item.id )
            this.popup = true
        },
        handleEventReturnData: function( formData ) {
            // console.log('handleEventReturnData: ', formData )
            
            this.statusOk = false
            this.complite = false
            this.waiting = true

            axios.post( '/rb/invoice', 
                { 
                    id: 'medpervichka',
                    item: this.item.id,
                    email: formData.email,
                    name: formData.name,
                    tel: formData.tel,
                    promocode: formData.promocode,
                },
                {
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                    }
                }
            ).then( res => {
                if ( res.status != 200 ) {
                    throw( res.status )
                }

                if ( res.data.url ) {
                    this.waiting = false 
                    this.complite = false
                    this.statusOk = true

                    window.location.href = res.data.url
                } else {
                    // this.popup = false
                    // this.item = {}
                    this.waiting = false 
                    this.complite = true
                    this.statusOk = false
                    console.log('res', res)
                }
            }).catch(error => {
                console.error("error:", error)
                this.waiting = false 
                this.complite = true
                this.statusOk = false
            })
            
        },
        handleEventReturnDataCompany: async function(data) {
            this.waiting = true
            this.complite = false
            this.statusOk = false
            axios.post( '/mailer', 
                {
                    ...data
                },
                {
                headers: { 'Content-Type': 'application/json' },
                }
            ).then( res => {
                if ( res.status != 200 ) {
                    throw( res.status )
                }

                this.waiting = false 
                this.complite = true
                this.statusOk = true
                
            }).catch(error => {
                console.error("error:", error)
                this.waiting = false 
                this.complite = true
                this.statusOk = false
            })
        },
        handleClickBuyCompany: function() {
            this.popup = true
            this.privatePerson = false
        },
        handleEventClosePopup: function() {
            this.waiting = false 
            this.complite = false
            this.statusOk = true
            this.popup = false
            this.privatePerson = true
            this.item = {}
        }
    },
}
</script>
<style lang="scss">
$pri: #45289C;
$sec: #1E9BD8;
$tre: #290a4f;
$text-color: #C0B8C9;

.tariff{
    margin-bottom: 1.5em;
    .__row{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        .__col{
            flex-basis: 100%;
            margin-bottom: 15px;
            // @media ( min-width: 580px ) {
            //     flex-basis: 45%;
            // }
            // @media ( min-width: 992px ) {
            //     flex-basis: 30%;
            //     margin-right: 10px;
            //     &:last-child{
            //         margin-right: 0;
            //     }
            // }
        }
    }
    .__company{
        button{
            background: none;
            color: #fff;
            border: none;
            font-size: 1em;
            cursor: pointer;
            // text-decoration: underline;
            border-radius: 15px;
            background-color: #1E9BD8;
            padding: 10px 15px;
            &:disabled{
                background: #50bbf555;
                color: #b8b8b892;
                cursor: auto;
            }
        }
    }
    h2{
        padding-left: 10px;
        font-weight: 700;
        @media ( min-width: 992px ) {
            padding-left: 0px;
        }
    }
}
</style>